
export const sFechaPublicacion = '2026-09-15T21:10:24.7689853-06:00';
export const sVersion = 'vf1.1.609152110';
            